<template>
  <div>
    <BaseHeader class="pb-6" type="default">
      <b-row align-v="center" class="py-4">
        <b-col lg="12" cols="7">
          <h1 class="h2 text-white d-inline-block mb-0">Nouvelle page</h1>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <RouteBreadcrumb />
          </nav>
        </b-col>
      </b-row>
    </BaseHeader>

    <PageForm :on-success="save" redirect="/pages/index" />
  </div>
</template>

<script>
import { RouteBreadcrumb, BaseHeader } from '@coop-zone/coop-zone-argon'
import PageForm from '@/components/Page/PageForm'

export default {
  components: {
    BaseHeader,
    PageForm,
    RouteBreadcrumb,
  },
  mounted() {
    this.$store.dispatch('pages/reset')
  },
  methods: {
    async save() {
      await this.$store.dispatch('pages/create')

      this.$notify({
        message: 'Page enregistrée',
        timeout: 5000,
        icon: 'ni ni-check-bold',
        type: 'success',
      })
    },
  },
}
</script>
